import React from 'react';
import { Button, ChevronDown, Menu, MusicNote01, Sliders02, Users01 } from '@opendate-app/setlist';

import './customWidgetBuilder/customWidgetBuilder.css';

export const WIDGET_TYPES = [
  {
    value: 'club',
    label: 'Club',
    icon: MusicNote01,
    description: 'The default widget layout ideal for most events. Patron is guided step-by-step.'
  },
  {
    value: 'festival',
    label: 'Festival',
    icon: Users01,
    description: 'Ideal for festival events. Offers more customizable options.'
  },
  {
    value: 'custom',
    label: 'Custom',
    icon: Sliders02,
    description: 'Build a fully customized widget with the visual builder.'
  }
];

const WidgetTypeDropdown = ({ widgetType, onSelect, customWidgetAvailable }) => {
  const availableTypes = WIDGET_TYPES.filter((t) => t.value !== 'custom' || customWidgetAvailable);
  const active = WIDGET_TYPES.find((t) => t.value === widgetType) || WIDGET_TYPES[0];

  return (
    <div className="cwb-widget-type-bar">
      <span className="cwb-widget-type-label">Widget Type</span>
      <Menu
        placement="bottom-start"
        minWidth={320}
        items={availableTypes.map((t) => ({
          key: t.value,
          label: t.label,
          description: t.description,
          icon: t.icon,
          onClick: () => {
            if (t.value !== widgetType) onSelect(t.value);
          }
        }))}
        trigger={
          <Button
            variant="secondary"
            size="sm"
            icon={active.icon}
            trailingIcon={ChevronDown}
            aria-label={`Widget type: ${active.label}`}
          >
            {active.label}
          </Button>
        }
      />
    </div>
  );
};

export default WidgetTypeDropdown;
